import { types } from "mobx-state-tree";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface AppointmentReasonInstance
  extends Instance<typeof AppointmentReason> {}
export interface AppointmentReasonSnapshotIn
  extends SnapshotIn<typeof AppointmentReason> {}
export interface AppointmentReasonSnapshotOut
  extends SnapshotOut<typeof AppointmentReason> {}

export const AppointmentReason = types.model("AppointmentReason", {
  id: types.identifier,
  name: types.string,
  description: types.maybeNull(types.string),
  durationInMinutes: types.maybeNull(types.number),
  hideDuration: types.maybeNull(types.boolean),
  clientNotesRequired: types.maybeNull(types.boolean),
  defaultPrice: types.maybeNull(
    types.model("DefaultPrice", {
      amount: types.number,
      currencyCode: types.string,
    }),
  ),
});
